import { TAB_DATA_FIELDS, TAB_DATA_FOR_FILTER_TYPE, TAB_DATA_VALUES } from "./constants";

export const getViewTabTitles = ({
    quantities, isTeacherUser
}) => {
    if (!quantities) return [];
    const tabs = [
        `(${quantities.general}) General`,
        `(${quantities.past}) Pasados`
    ];
    if (!isTeacherUser) 
        tabs.push(
            `(${quantities.draft}) Borrador`,
        );
    tabs.push(`(${quantities.canceled}) Cancelados`);
    if (!isTeacherUser) 
        tabs.push(
            `(${quantities.unprocessed}) No Procesados`
        );
    return tabs;
}
export const getTabData = (isTeacherUser) => {
    if (isTeacherUser) 
        return {
            fields: TAB_DATA_FIELDS.TEACHER,
            values: TAB_DATA_VALUES.TEACHER,
            filterTypes: TAB_DATA_FOR_FILTER_TYPE.TEACHER
        };
    return {
        fields: TAB_DATA_FIELDS.ADMIN,
        values: TAB_DATA_VALUES.ADMIN,
        filterTypes: TAB_DATA_FOR_FILTER_TYPE.ADMIN
    };
}